module.exports = __webpack_public_path__ + "static/media/valuenex.b2bc6555.png";